import { useContext, useState } from 'react';
import { ChatContext } from '../contexts/ChatContext';
import { Container, Stack, Spinner } from 'react-bootstrap';
import UserChat from '../components/chat/UserChat';
import { UserContext } from '../contexts/UserContext'
import PossibleChat from '../components/chat/PossibleChat';
import { ChatBox } from '../components/chat/ChatBox';
import Media from 'react-media';
import Icon from '@mdi/react';
import {mdiEmoticonSad} from '@mdi/js';

const Chat = () => {

	const { user } = useContext(UserContext);
	const { userChats, isUserChatsLoading, updateCurrentChat } = useContext(ChatContext);
	const [showChatBox, setShowChatBox] = useState('No selected conversation...');
	const [selectedChat, setSelectedChat] = useState(null);

	const handleChatClick = (chat) => {
		updateCurrentChat(chat);
		setSelectedChat(chat);
		setShowChatBox(true);
	}

	return (
		<Container>
			<Media query="(min-width: 600px)">
			{matches => {
				return matches?
				<>
				<PossibleChat />
				{userChats?.length < 1 ? null :
					<Stack direction="horizontal" gap={4} className="align-items-start">
						<Stack className="col-md-4">
							{isUserChatsLoading && 	
							<>	
							<p>Loading Chats...</p>		
							<Spinner animation="grow" variant="primary" />
					     	<Spinner animation="grow" variant="success" />
					      	<Spinner animation="grow" variant="danger" />
					      	</>}
							{userChats?.map((chat, index) => {
								return (
									<div key={index} onClick={() => handleChatClick(chat)}>
										<UserChat chat={chat} user={user} />
									</div>
								)
							})}
						</Stack>
						<Stack className="col-md-8">
							{showChatBox && <ChatBox chat={selectedChat} />}
						</Stack>
					</Stack>
				}
				</>
				:
				<>
					<div className="text-center">
						<h1>This device is currently not supported. Please use desktop for now.</h1>
						<Icon path={mdiEmoticonSad} size={10} />
					</div>
				</>
			}}
			</Media>
		</Container>
	)
}

export default Chat;
